<template>
  <i v-if="props.sortable" :class="icon" style="margin-left: 0.5rem;"/>
</template>
<style lang="scss">
.color-icon{
  color: #0066CC;
  font-size: 15px;
}
.color-icon-dafault{
  color: #64748b;
  opacity: 0.8;
}
</style>

<script>
export default {
  name: 'VtSortControl',
  props: ['props'],
  computed: {
    icon () {
      // sortStatus = { sorted: Boolean, asc: Boolean }

      // if not sorted return base icon
      if (!this.props.sortStatus.sorted) return 'fas fa-arrows-alt-v color-icon-dafault'

      // return sort direction icon
      return this.props.sortStatus.asc ? 'fas fa-long-arrow-alt-up color-icon' : 'fas fa-long-arrow-alt-down color-icon'
    }
  }
}
</script>
